import React, { lazy } from 'react';
import { StarIcon } from 'lucide-react';
export function EarlyTestimonials() {
  const testimonials = [{
    name: 'Maria C.',
    quote: "Natural remedies finally make sense. I've stopped buying cold medicine constantly.",
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Elena G.',
    quote: 'My digestion improved more in 2 weeks than years of prescriptions.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Kathy W.',
    quote: 'Easy recipes, ingredients from my kitchen. I feel better and sleep better.',
    image: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop&crop=faces'
  }];
  return <div className="w-full bg-white py-12" data-id="element-165">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-167">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-stone-50 rounded-xl p-6" data-id="element-168">
              <div className="flex gap-1 mb-3" data-id="element-169">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" data-id="element-170" />)}
              </div>
              <p className="text-stone-700 mb-4 leading-relaxed" data-id="element-171">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-172">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover" loading="lazy" data-id="element-173" />
                <p className="text-stone-900 font-semibold" data-id="element-174">
                  — {testimonial.name}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}